export default __webpack_public_path__ + "static/media/ars-maquette-regular-webfont.50257ddf.ttf";